import React, { useRef, useState } from "react";
import { TitleBlock, Note, Actions, PrimaryBtn, SecondaryBtn } from "../../../../auth/v2/pieces";
import camera from "../../../../../assets/brand/onboarding/camera.svg";

// 12 · Add a profile photo.
export const PhotoStep = ({ state, onUpload, onSkip }) => {
  const fileRef = useRef(null);
  const cameraRef = useRef(null);
  const [preview, setPreview] = useState(state.avatar || "");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type) && !/\.(jpe?g|png|webp|heic)$/i.test(file.name)) { setError("Use a JPG or PNG."); return; }
    if (file.size > 10 * 1024 * 1024) { setError("That photo is over 10MB."); return; }
    setBusy(true); setError("");
    try {
      const url = await onUpload(file);
      setPreview(url || URL.createObjectURL(file));
    } catch (e) { setError(e.message || "We could not upload that photo."); } finally { setBusy(false); }
  };
  return (
    <>
      <TitleBlock eyebrow="Photo" title="Add a profile photo" sub="This is the first thing a brand sees when you show up in their search." />
      <button
        type="button"
        onClick={() => fileRef.current?.click()}
        className="flex w-full flex-col items-center gap-[14px] rounded-[24px] border-[1.5px] border-dashed border-bm-strong bg-bm-subtle px-6 py-9 text-center hover:border-bm-ink"
      >
        {preview ? (
          <img src={preview} alt="" className="h-[112px] w-[112px] rounded-full border border-bm-border object-cover" />
        ) : (
          <span className="flex h-[112px] w-[112px] items-center justify-center rounded-full bg-bm-mutedbg"><img src={camera} alt="" className="h-[30px] w-9" /></span>
        )}
        <span className="bm-label-l text-bm-ink">{preview ? "Photo added. Tap to change it" : "Tap to take a photo or choose one"}</span>
        <span className="bm-body-s text-bm-muted">A clear headshot works best. JPG or PNG, up to 10MB.</span>
      </button>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
      <input ref={cameraRef} type="file" accept="image/*" capture="user" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
      <Note>You can skip this and add a photo later from your profile.</Note>
      {error && <Note tone="critical">{error}</Note>}
      <Actions>
        {preview ? <PrimaryBtn onClick={onSkip} loading={busy}>Continue</PrimaryBtn> : <PrimaryBtn onClick={() => cameraRef.current?.click()} loading={busy}>Take a photo</PrimaryBtn>}
        <SecondaryBtn onClick={() => fileRef.current?.click()} disabled={busy}>Choose from library</SecondaryBtn>
      </Actions>
    </>
  );
};
